import colors from './colors';
import lightTheme from './lightTheme';

export default lightTheme(colors);
